export default "__VITE_ASSET__8VR4bAt$__"